
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.083 14.417a.806.806 0 010 1.167.757.757 0 01-.584.25.757.757 0 01-.583-.25l-5-5a.806.806 0 010-1.167l5-5a.806.806 0 011.167 0 .806.806 0 010 1.167L8.666 10l4.417 4.417z","fill":"#000"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"6","y":"4","width":"8","height":"12"}},[_c('path',{attrs:{"d":"M13.083 14.417a.806.806 0 010 1.167.757.757 0 01-.584.25.757.757 0 01-.583-.25l-5-5a.806.806 0 010-1.167l5-5a.806.806 0 011.167 0 .806.806 0 010 1.167L8.666 10l4.417 4.417z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#284A33","d":"M0 0h20v20H0z"}})])])
          )
        }
      }
    